import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDatatable = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "table_chart_24px",
		children: /* @__PURE__ */ _jsx("path", {
			id: "icon/editor/table_chart_24px",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.5 3H4.5C3.4 3 2.5 3.9 2.5 5V8H21.5V5C21.5 3.9 20.6 3 19.5 3ZM19.5 21H16.5V10H21.5V19C21.5 20.1 20.6 21 19.5 21ZM14.5 10.02H9.5V21H14.5V10.02ZM4.5 21C3.4 21 2.5 20.1 2.5 19V10H7.5V21H4.5Z",
			fill: "currentColor"
		})
	})
});
export default SvgDatatable;
